import * as React from 'react';
import ResultListItem from './ResultListItem';
import SearchResult from './SearchResult';

interface Props {
    results: SearchResult[];
    query: string;
}

export default class ResultList extends React.Component<Props> {

    public render(): React.ReactNode {
        return (
            <table>
                <tbody>
                    {this.props.results.map(result => <ResultListItem key={result.number} result={result} query={this.props.query} />)}
                </tbody>
            </table>
        );
    }
}
